import { Show, createEffect, createMemo, createSignal, on } from "solid-js";

import { GetUnread } from "@/api/clientApi/notice.ts";
import { GetUserPayChannelV2 } from "@/api/clientApi/wallet.ts";
import GradientBorderButton from "@/components/Base/GradientBorderButton/index.tsx";
import Icon from "@/components/Icon";
import { getImageAltByLang } from "@/constants/seo-constants.ts";
import {
  notificationStore,
  setNotificationStore,
} from "@/hooks/useNotification.ts";
import { useRouter } from "@/hooks/useRouter.tsx";
import { getLocale, useI18n } from "@/i18n";
import { formatToBindPoint } from "@/lib/pointUtils.ts";
import { getImgurl } from "@/lib/resFolder.ts";
import { sdkManager } from "@/lib/sdk/sdkManager.ts";
import { cn } from "@/lib/tailwindcssTool.ts";
import { removeLocalePrefix } from "@/lib/urlUtils.ts";
import { getWebsiteConfigV2 } from "@/stores/configStore.ts";
import { getVipItem } from "@/stores/depositStore.tsx";
import { sidebarStore } from "@/stores/sidebar.ts";
import { sidebarContainerStore } from "@/stores/sidebarContainerStore.ts";
import { sysConfigStore } from "@/stores/sysConfigStore.ts";
import { userStore } from "@/stores/userStore.ts";
import { useLocation } from "@solidjs/router";

import BonusDropdownMenu from "./BonusDropdownMenu.tsx";
import UserDropdownMenu from "./UserDropdownMenu.tsx";
import WalletDropdownMenu from "./WalletDropdownMenu.tsx";

export default function PCHeader() {
  const { t } = useI18n();
  const location = useLocation();
  const { push, toDeposit, preCheckEnterGame } = useRouter();
  const count = createMemo(() => notificationStore.count);

  createEffect(
    on(
      () => userStore.isLogin,
      (isLogin) => {
        if (isLogin) {
          console.log("get unread");
          GetUnread({ msg_type: 0 }).then((res) => {
            const count = (res?.unread?.[1] || 0) + (res?.unread?.[2] || 0);
            setNotificationStore("count", count);
          });
        }
      },
    ),
  );

  const [activeTab, setActiveTab] = createSignal<number | null>(null);
  // 活动和道具间不比较
  const [displayAmount, setDisplayAmount] = createSignal<string | null>(null);

  const isLogin = createMemo(() => userStore.isLogin);

  createEffect(
    on(
      createMemo(() => location.pathname),
      () => {
        const currentPath = removeLocalePrefix(location.pathname) || "";
        if (currentPath === "/") {
          setActiveTab(0);
        } else if (currentPath.includes("sports")) {
          setActiveTab(1);
        } else {
          setActiveTab(null);
        }
      },
    ),
  );

  // createEffect(() => {
  //   getDepositReward();
  // });
  createEffect(
    on(
      () => userStore.isLogin,
      () => {
        getDepositReward();
      },
      // {
      //   defer: true,
      // },
    ),
  );

  const getDepositReward = async () => {
    const res = await GetUserPayChannelV2({
      point_type: sysConfigStore.point_type,
    });
    if (res) {
      if (res?.discount?.activity_list) {
        res?.discount?.activity_list.map((item) => {
          if ([65].includes(item.atype)) {
            const vip_level = userStore.userInfo?.UserVip?.vip_level;
            const vipItem = getVipItem(
              item?.activity_config?.vip_cfg,
              vip_level,
            );
            // 匹配等级
            if (!vipItem) {
              console.log(vipItem);
              item.result = "0";
              return item;
            }
            const activityItem =
              vipItem?.reward_cfg?.[vipItem?.reward_cfg.length - 1];
            if (activityItem?.reward?.reward_point_mode === 1) {
              setDisplayAmount(
                formatToBindPoint({
                  value: activityItem?.reward?.point,
                  pointType: sysConfigStore.point_type,
                  showSymbol: true,
                  bDeleteZeroPoint: true,
                }),
              );
            } else {
              setDisplayAmount(`${activityItem?.reward?.pay_pro / 100}%`);
            }
          } else if ([13].includes(item.atype)) {
            const activityItem =
              item?.activity_config?.list?.[
                item?.activity_config?.list.length - 1
              ];
            if (activityItem?.reward?.reward_point_mode === 1) {
              setDisplayAmount(
                formatToBindPoint({
                  value: activityItem?.reward?.point,
                  pointType: sysConfigStore.point_type,
                  showSymbol: true,
                  bDeleteZeroPoint: true,
                }),
              );
            } else {
              setDisplayAmount(`${activityItem?.reward?.pay_pro / 100}%`);
            }
          } else {
            const activityItem =
              item?.activity_config?.list?.[
                item?.activity_config?.list.length - 1
              ];
            if (activityItem?.reward?.reward_point_mode === 1) {
              setDisplayAmount(
                formatToBindPoint({
                  value: activityItem?.reward?.point,
                  pointType: sysConfigStore.point_type,
                  showSymbol: true,
                  bDeleteZeroPoint: true,
                }),
              );
            } else {
              setDisplayAmount(`${activityItem?.reward?.pay_pro / 100}%`);
            }
          }
        });
      }
      if (res?.discount?.promoitem_list) {
        const promoitem_list = res.discount?.promoitem_list;
        const resultProp = promoitem_list?.[0];
        const cfg_data = JSON.parse(resultProp.cfg_data);
        const config = JSON.parse(cfg_data?.config);
        // const item_lang = JSON.parse(cfg_data?.item_lang);
        const detail = config?.reward_list[config?.reward_list.length - 1];
        if (config?.reward_type === 0) {
          setDisplayAmount(
            formatToBindPoint({
              value: detail?.value,
              pointType: sysConfigStore.point_type,
              showSymbol: true,
              bDeleteZeroPoint: true,
            }),
          );
        } else {
          setDisplayAmount(`${detail?.value / 10000}%`);
        }
      }
    }
  };

  // 处理游戏类型标签切换
  async function handleTabChange(tab: number) {
    const defaultSportGameId = sysConfigStore.sport_config.sport_game_id;
    if (tab == 1) {
      if (userStore.isLogin) {
        const pass = await preCheckEnterGame({
          gid: `${defaultSportGameId}`,
          // itemId: `${props?.itemId}`,
          // bindPointType: bindPointType,
        });
        if (!pass) {
          return;
        }
      }
      push(`/sports/${defaultSportGameId}`);
    } else {
      push("/");
    }
    setActiveTab(tab);
  }

  return (
    <header
      class="z-[1000] flex !h-[72px] bg-[var(--colors-surface-bg-9)] pl-[6px]"
      classList={{
        "w-[calc(100%-400px)] pr-6 gap-6":
          sidebarContainerStore.state.isExpanded,
      }}
    >
      <div class="relative flex h-14 w-[236px] shrink-0 items-center rounded-[var(--md)] bg-[var(--colors-surface-bg-8)] pl-[66px]">
        <div class="absolute left-0 top-1/2 mr-[6px] flex h-[60px] w-[60px] -translate-y-1/2 cursor-pointer items-center justify-center rounded-[8px] bg-[var(--colors-surface-bg-8)]">
          <GradientBorderButton
            wrapClass="from-[var(--colors-surface-bg-7)] to-[var(--colors-surface-bg-6)] !shrink-0"
            borderClass="from-(--colors-border-icon-top5) to-(--colors-border-icon-bottom10)"
            onClick={sidebarStore.toggleSidebar}
          >
            <Icon
              name="thumb"
              wrapperClass="w-8 h-8"
              class="h-4 w-4"
              color="var(--colors-icon-btn-default)"
            />
          </GradientBorderButton>
        </div>
        <img
          src={`/${__APP_NAME__}/images/logo/logo.png`}
          width={"auto"}
          height={36}
          alt={getImageAltByLang("logo")}
          class="clickable mb-[auto] mt-[auto] h-[36px] w-auto shrink-0"
          onClick={() => {
            push("/");
            sdkManager.tdReportEvent("logo_nav_click", {
              source: window.location.pathname,
            });
          }}
        />
      </div>
      <div class="flex h-full flex-1 items-center justify-center">
        <div class="wrap h-full font-['Alexandria']">
          <div class="flex h-full w-full items-center justify-between">
            {/* left */}
            <div class="flex h-12 items-center gap-2 rounded-[var(--lg)] bg-[var(--colors-surface-bg-8)] px-1">
              <div
                class="flex h-10 cursor-pointer items-center gap-2 rounded-[var(--md)] border-[1px] border-transparent px-4 text-[var(--colors-text-secondary)]"
                classList={{
                  "!bg-(--colors-btn-brand-accent-default) !border-(--colors-btn-border-accent) !text-(--colors-text-primary)":
                    activeTab() === 0,
                }}
                onclick={() => handleTabChange(0)}
              >
                <Icon
                  name="ball"
                  class={`size-4 ${activeTab() === 0 ? "text-[var(--colors-icon-invert-btn)]" : "text-[var(--colors-icon-btn-default)]"}`}
                />
                <div class="text-[14px] font-bold leading-[14px]">
                  {t("home.casino")}
                </div>
              </div>
              <div
                class="flex h-10 cursor-pointer items-center gap-2 rounded-[var(--md)] border-[1px] border-transparent px-4 text-[var(--colors-text-secondary)]"
                classList={{
                  "!bg-(--colors-btn-brand-accent-default) !border-(--colors-btn-border-accent) !text-(--colors-text-primary)":
                    activeTab() === 1,
                }}
                onClick={() => handleTabChange(1)}
              >
                <Icon
                  name="bottom-nav/sport"
                  class={`size-4 ${activeTab() === 1 ? "text-[var(--colors-icon-invert-btn)]" : "text-[var(--colors-icon-btn-default)]"}`}
                />
                <div class="text-[14px] font-bold leading-[14px]">
                  {t("home.sports")}
                </div>
              </div>
            </div>
            {/* right */}
            <div class="flex items-center gap-2">
              <Show
                when={isLogin()}
                fallback={
                  <>
                    <GradientBorderButton
                      wrapClass="shadow-[0_4px_10.7px_0_rgba(0,0,0,0.25)]"
                      onClick={() => push("login")}
                    >
                      <div class="flex h-[38px] items-center px-4">
                        <span class="text-[14px] font-bold leading-[14px] text-[var(--colors-text-primary)]">
                          {t("auth.sign_in")}
                        </span>
                      </div>
                    </GradientBorderButton>
                    <div
                      class="border-1 bg-main-linear flex h-[38px] cursor-pointer items-center justify-center rounded-[8px] border-[var(--colors-btn-border-default)] px-4 text-[14px] font-bold leading-[14px] text-[var(--colors-text-brand)]"
                      onClick={() => push("register")}
                    >
                      {t("auth.sign_up")}
                      <Show
                        when={getWebsiteConfigV2()?.registerRewardSwitch}
                        fallback={<></>}
                      >
                        <div class="absolute top-[56px] ml-[-62px]">
                          <img
                            src={getImgurl(
                              `top-${getLocale()}.png`,
                              "common/home/deposit-act/locale",
                            )}
                            class={cn("w-[184px] shrink-0")}
                          />
                        </div>
                      </Show>
                    </div>
                  </>
                }
              >
                <div class="flex h-[41px] items-center gap-2 rounded-lg bg-[var(--colors-surface-bg-8)] pl-3 pr-1">
                  <WalletDropdownMenu />
                  <div
                    class="bg-main-linear flex h-[33px] cursor-pointer items-center rounded-[var(--md)] border-[1px] border-[var(--colors-btn-border-default)] px-3 text-[var(--colors-text-brand)]"
                    onclick={() => toDeposit()}
                  >
                    <span class="text-[13px] font-bold leading-[13px] text-[var(--colors-text-brand)]">
                      {t("affiliate.deposit")}
                    </span>
                    <Show when={displayAmount()} fallback={<></>}>
                      <div class="absolute top-[56px] ml-[-66px]">
                        <img
                          src={getImgurl(
                            `top-1.png`,
                            "common/home/deposit-act",
                          )}
                          class={cn("h-[42px] w-[141px] shrink-0")}
                        />
                        <span class="text-general-light absolute ml-[36px] mt-[-23px] w-[95px] text-center text-[12px] font-bold">
                          {t("deposit.max_bonus", {
                            val: displayAmount() || "",
                          })}
                        </span>
                      </div>
                    </Show>
                  </div>
                </div>
                {/* 奖金中心 */}
                <BonusDropdownMenu />

                {/* 用户中心 */}
                <UserDropdownMenu />
                <Show when={isLogin()} fallback={<></>}>
                  <GradientBorderButton
                    wrapClass="from-[var(--colors-surface-bg-7)] to-[var(--colors-surface-bg-6)]"
                    onClick={sidebarContainerStore.toggleSidebar}
                    borderClass="from-[var(--colors-border-icon-top5)] to-[var(--colors-border-icon-bottom10)]"
                  >
                    <div class="flex size-8 items-center justify-center">
                      <Icon
                        name="general/notify4"
                        class={`clickable text-(--colors-icon-btn-default) h-4 w-4`}
                      />

                      <Show when={count() > 0} fallback={<></>}>
                        <div class="absolute right-[5.5px] top-[4.5px] h-[5px] w-[5px] rounded-full bg-[var(--colors-icon-green-brand)]" />
                      </Show>
                    </div>
                  </GradientBorderButton>
                </Show>
              </Show>
              {/* <GradientBorderButton
                wrapClass="from-[var(--colors-surface-bg-7)] to-[var(--colors-surface-bg-6)]"
                onClick={() => showDialog({ type: DialogType.SwitchLanguage })}
                borderClass="from-[var(--colors-border-icon-top5)] to-[var(--colors-border-icon-bottom10)]"
              >
                <div class="flex size-8 items-center justify-center">
                  <Icon
                    name="menu/globe"
                    class="size-4"
                    color="var(--colors-icon-btn-default)"
                  />
                </div>
              </GradientBorderButton> */}
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
